import { render, staticRenderFns } from "./NumeroClicks.vue?vue&type=template&id=1aeb7746"
import script from "./NumeroClicks.vue?vue&type=script&lang=js"
export * from "./NumeroClicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports